import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=063b0340"
import script from "./TermCondition.vue?vue&type=script&lang=js"
export * from "./TermCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports